module.exports = __webpack_public_path__ + "img/company-img3.7a00c1e5.png";